import { render, staticRenderFns } from "./TogglePlans.vue?vue&type=template&id=89f6cc16"
import script from "./TogglePlans.vue?vue&type=script&setup=true&lang=ts"
export * from "./TogglePlans.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports